<template>
  <div class="cartouchePublic">
    <div style="font-size:20px;" :class="window.width < 480 ? 'container-fluid' : 'container'">
      <div>
        <span
          style="cursor:pointer"
          v-if="
            parameters === 'adminPage' ||
              parameters === 'questionner' ||
              parameters === 'projeter' ||
              parameters === 'animer'
          "
          @click="returnFunction()"
        >
          <img src="@/assets/img/public_logo.png" alt="logo-textit" /> textit
        </span>
        <div class="is-pulled-right">
          <b-tooltip label="Fullscreen" position="is-left">
            <img
              v-if="
                parameters === 'projeter'"
              @click="fullscreen"
              style="cursor:pointer;width:20px;height:20px;margin-top:10px;"
              src="@/assets/img/icons/full-screen.png"
              alt="full-screen-icon"
            />
          </b-tooltip>
          <img
            @click="searchBar()"
            v-if="parameters === 'adminPage'"
            style="cursor:pointer;width:20px;height:20px;"
            src="@/assets/img/icons/searchbar-icon.png"
            alt="searchbar-icon"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Header",
  props: ['window', 'parameters'],
  computed: {
    ...mapGetters(["adminActiveComponents"])
  },
  methods: {
    returnFunction() {
      switch (this.parameters) {
        case "adminPage":
          this.$store.commit("ADMIN_ACTIVE_COMPONENTS", {
            cardList: true,
            parameters: false
          });
          break;
        case "questionner":
          this.$router.replace({ name: "home" }).catch(err => {});
          break;
        case "projeter":
          this.$router.push("/admin");
          break;
        case "animer":
          this.$router.push("/admin");
          break;
      }
    },
    searchBar() {
      this.$store.commit("ADMIN_ACTIVE_COMPONENTS", {
        searchBar: !this.adminActiveComponents.searchBar,
        cardList: true
      });
    },
    fullscreen() {
      var elem = document.documentElement;

      if (!this.isFullscreen) {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
          /* Firefox */
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
          /* Chrome, Safari and Opera */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          /* IE/Edge */
          elem.msRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          /* Firefox */
          document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
          /* Chrome, Safari and Opera */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
          /* IE/Edge */
          document.msExitFullscreen();
        }
      }
      this.isFullscreen = !this.isFullscreen;
    }
  }
};
</script>

<style scoped>
.cartouchePublic {
  background: #424a60;
  color: white;
  text-align: left;
  height: 40px;
  font-size: 24px;
  z-index: 1000;
  position: relative;
}

.cartouchePublic img {
  height: 26px;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue